import Link from 'next/link';
import Image from 'next/image';
import clsx from 'clsx';
import { useTranslate } from 'app/[locale]/hooks/useTranslate';
import analyticsInstance from 'libs/rtzr-commons/modules/marketing/Analytics';

export const QRButton = ({
  className,
  isQRCodeVisible = true,
  title,
  icon,
  qrCodeImage,
  href,
}: {
  className?: string;
  isQRCodeVisible?: boolean;
  title: string;
  icon: string;
  qrCodeImage: string;
  href: string;
}): JSX.Element => {
  const { t } = useTranslate();

  // TODO: 션한테 확인 후 링크 구조 수정 필요
  return (
    <div className={clsx('relative flex flex-row items-end gap-1 lg:flex-col lg:gap-5', className)}>
      <Link
        href={href}
        target="_blank"
        passHref
        className="flex justify-center items-center gap-2 whitespace-nowrap p-3.5 lg:p-5 cursor-pointer border border-solid border-gray-fog rounded bg-white-hover md:w-fit w-[135px]"
      >
        <button
          onMouseDown={() => {
            analyticsInstance.logEvent('click_app_url', {
              name: title,
            });
          }}
          className="flex lg:gap-2 gap-1 items-center"
        >
          <Image
            src={icon}
            width={16}
            height={16}
            className="flex-shrink-0 lg:w-5 lg:h-5 w-6 h-6"
            alt={title}
          />
          <span className="text-sm lg:text-base font-semibold">{title}</span>
        </button>
        <div className="w-px bg-gray-fog h-full hidden lg:flex" />
        {isQRCodeVisible && (
          <>
            <div className="peer cursor-pointer justify-center items-center hidden lg:flex">
              <Image src="/callabo/store/qr_icon.svg" width={20} height={20} alt="qr" />
            </div>
            <div className="hidden peer-hover:block absolute left-0 top-[70px] z-[100]">
              <div className="w-[338px] flex justify-between p-6 rounded-xl bg-white shadow">
                <div>
                  <h4 className="text-sm font-semibold mb-[17px]">
                    {t.integration.MOBILE_APP_POPUP_TITLE}
                  </h4>
                  <p className="flex items-center gap-3.5 text-sm font-normal text-gray-iron">
                    <Image
                      src={icon}
                      width={20}
                      height={20}
                      alt={title}
                      className="flex-shrink-0"
                    />
                    <span>{title}</span>
                  </p>
                </div>
                <Image
                  src={qrCodeImage}
                  width={146}
                  height={146}
                  className="flex-shrink-0"
                  alt="qr code"
                />
              </div>
            </div>
          </>
        )}
      </Link>
    </div>
  );
};
